module.exports = __webpack_public_path__ + "root-c2082cbd/014075a19324e79172d633ff84c4df1c.svg";